import { render, staticRenderFns } from "./Placement.vue?vue&type=template&id=5eefa7fe"
import script from "./Placement.vue?vue&type=script&lang=js"
export * from "./Placement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports